import * as RadixRadioGroup from '@radix-ui/react-radio-group';
import { Circle } from 'phosphor-react';
import { useId } from 'react';

type RadioGroupProps = {
  options: string[];
  selectedOption: string;
  onOptionChange: (value: string) => void;
};

export const RadioGroup = ({ options, selectedOption, onOptionChange }: RadioGroupProps) => {
  return (
    <RadixRadioGroup.Root className="flex flex-col gap-100" onValueChange={onOptionChange} value={selectedOption}>
      {options.map(option => <RadioItem key={option} value={option} />) }
    </RadixRadioGroup.Root>
  );
};

type RadioItemProps = {
  value: string;
};

const RadioItem = ({ value }: RadioItemProps) => {
  const id = useId();

  return (
    <div className="flex gap-100">
      <RadixRadioGroup.Item value={value} id={id} className="flex-shrink-0 tds-radiobutton w-300 h-300">
        <RadixRadioGroup.Indicator className="flex items-center justify-center">
          <Circle className="tds-radiobutton-icon" weight="fill" />
        </RadixRadioGroup.Indicator>
      </RadixRadioGroup.Item>
      <label htmlFor={id} className="tds-input-value tds-input-value-default tds-radiobutton-label">{value}</label>
    </div>
  );
};

